<template>
    <div class="problem-area">
        <div
            ref="problem-scrollbar"
            class="problem-container scrollbar"
            :style="{ bottom: showEditor ? '200px' : 0 }"
        >
            <div class="problem-list">
                <message
                    v-for="(problem, index) in problemList"
                    :key="index"
                    :no="index + 1"
                    :nickName="problem.userName"
                    :avatar="problem.isMe ? userInfo.avatar : problem.userAvatar"
                    :content="problem.content"
                    :answers="problem.answers"
                    class="problem-item"
                ></message>
            </div>
        </div>
        <div v-if="showEditor" class="problem-editor-area flex flex-column">
            <div class="problem-editor-title flex flex-vertical-center">
                <img src="@images/player/question.png" class="problem-editor-icon" />
                <span>提问区</span>
            </div>
            <el-input
                v-model="content"
                type="textarea"
                class="flex-item problem-editor"
                :autosize="false"
                resize="none"
                placeholder="请输入你的问题"
            >
            </el-input>
            <div class="flex flex-end problem-editor-footer">
                <el-button type="primary" class="send-btn" round @click="handleSendQuestion"
                    >发送</el-button
                >
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Message from './Message.vue';
export default {
    name: 'ProblemArea',
    components: { Message },
    props: {
        problemList: {
            type: Array,
            default: () => []
        },
        showEditor: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            content: ''
        };
    },
    computed: {
        ...mapGetters(['userInfo'])
    },
    updated() {
        const $problemScrollerBar = this.$refs['problem-scrollbar'];
        $problemScrollerBar.scrollTo(0, $problemScrollerBar.scrollHeight);
    },
    methods: {
        handleSendQuestion() {
            this.$emit('send', this.content);
            this.content = '';
        }
    }
};
</script>

<style lang="scss" scoped>
.problem-area {
    height: 100%;
    position: relative;
}
.problem {
    &-container {
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 200px;
    }
    &-list {
        padding: 0 17px;
    }
    &-item {
        & + & {
            margin-top: 17px;
        }
    }
}
.problem-editor {
    &::v-deep {
        .el-textarea__inner {
            height: 100%;
            background-color: transparent;
            border: none;
            padding: 15px 24px;
            color: #bbbbbb;
            scrollbar-color: #545454 transparent;
            scrollbar-width: thin;
            &::placeholder {
                color: #5e5e60;
            }
            &::-webkit-scrollbar-track-piece {
                background-color: transparent;
                border-radius: 0;
            }
            &::-webkit-scrollbar {
                width: 8px;
                height: 8px;
            }
            &::-webkit-scrollbar-thumb {
                height: 50px;
                background-color: #545454;
                outline-offset: -2px;
                border-radius: 6px;
                // outline: 2px solid #fff;
                // border: 2px solid #fff;
                filter: alpha(opacity = 50);
                -moz-opacity: 0.5;
                -khtml-opacity: 0.5;
                opacity: 0.5;
            }
            &::-webkit-scrollbar-thumb:hover {
                height: 50px;
                background-color: #878987;
                border-radius: 6px;
            }
        }
    }
    &-area {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 190px;
        margin-top: 10px;
    }
    &-title {
        height: 44px;
        padding: 0 14px;
        font-size: 12px;
        color: #bbbbbb;
        background-color: #2b2b2d;
    }
    &-icon {
        width: 20px;
        height: 20px;
        object-fit: contain;
        margin-right: 7px;
    }
    &-footer {
        padding: 10px;
    }
}
.send-btn {
    padding: 10px 19px !important;
    line-height: 14px !important;
    background-color: #2b60b6;
    border-color: #2b60b6;
}
</style>
